import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  BerthVisit,
  ExemptionOudeMaas
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-visit-exemptions-exemption-oude-maas',
    templateUrl: './exemption_oude-maas.html',
    styleUrls: ['./exemption_oude-maas.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionOudeMaasComponent extends ExemptionBaseComponent {

  @Input() exemption: ExemptionOudeMaas;
  @Input() berthVisit : BerthVisit;

  portVisitUtils = PortvisitUtils;

  get inboundTripName() {
    if (!this.exemption['inboundTripName']) {
      return this.berthVisit.berth.name;
    }
    return this.exemption['inboundTripName'];
  }

  set inboundTripName(inboundTripName: string) {
    this.exemption['inboundTripName'] = inboundTripName;
  }

  get outboundTripName() {
    if (!this.exemption['outboundTripName']) {
      return this.berthVisit.berth.name;
    }
    return this.exemption['outboundTripName'];
  }

  set outboundTripName(outboundTripName: string) {
    this.exemption['outboundTripName'] = outboundTripName;
  }

  resetInboundTrip() {
    this.exemption.inboundLocationName = '';
    this.exemption.inboundTripEndDate = '';
    this.exemption.inboundTripStartDate = '';
    this.exemption.inboundTripAirDraft = null;
    this.exemption.inboundTripFreshWaterDraft = null;
  }

  resetOutboundTrip() {
    this.exemption.outboundLocationName = '';
    this.exemption.outboundTripEndDate = '';
    this.exemption.outboundTripStartDate = '';
    this.exemption.outboundTripAirDraft = null;
    this.exemption.outboundTripFreshWaterDraft = null;
  }
}
